/**
 * Default page size for audit logs pagination
 */
export const AUDIT_LOGS_PAGE_SIZE = 20;
